/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import { keyBy } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import Typography from "../../../../components/common/new/Typography/Typography";
import GohonzonOtherInput from "../../../../components/GohonzonOtherInput/GohonzonOtherInput";
import {
  okatakiGohonzonQuestions,
  okatakiGohonzonQuestionsForMember,
} from "../../../../contants/gohonzon";
// import { okatakiGohonzonQuestions } from "../../../../contants/gohonzon";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import { isEmptyObj } from "../../../../utils/helper";
import styles from "../GohonzonSubmission.styles";
import { GOHONZON_SUBMISSION } from "../../../../contants/formFields";
import { SelectMonthAndYear } from "../../../../components/common/new/YearAndMonthDropDown/YearAndMonthDropDown";

const DROPDOWN = "DROPDOWN";
const PROPOSED = "PROPOSED";

function OkatakiFormQuestion({
  handleChange,
  title,
  answers,
  name,
  setFieldValue,
  member,
}) {
  const { isDistrictSi, isChapterSi, isRegionSi, isHelpDesk, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);
  const readOnly = isChapterSi || isRegionSi || isHelpDesk || isHelpDeskAdmin;
  const answersMap = keyBy(answers, "questionId");

  const getAnswerValue = (question) => {
    if (!answers?.length || !answers) return "";
    if (!isEmptyObj(answersMap?.[question.questionId])) {
      const value = answersMap?.[question.questionId];

      return typeof value.answer === "boolean"
        ? value.answer
          ? "YES"
          : "NO"
        : value.answer;
    }

    return "";
  };

  return (
    <Box mb={8}>
      <Box py="18px">
        <div style={{ display: " flex" }}>
          <Box
            style={{
              width: "230px",
              height: "44px",
              flexShrink: "0",
              borderRadius: "35px",
              background: "#196AAB",
              marginBottom: "-35px",
              position: "relative",
              zIndex: "1",
              marginLeft: "45px",
            }}
          >
            <Typography
              variant="title3"
              style={{
                color: "#FFF",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Noto Sans",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                padding: "12px 26px 12px 18px",
                margin: "0",
              }}
            >
              {title}
            </Typography>
          </Box>
        </div>
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        <Box style={styles.gridContainer}>
          <Box style={{ ...styles.paiarStyles, background: "#FFF" }} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "25px 0px 0px 30px",
            }}
          >
            <Typography
              color="#8c8c8c"
              fontSize="13px"
              marginLeft="45px"
              marginBottom="20px"
              style={{
                color: "#484848",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontStyle: "normal",
                fontWeight: "600",
                lineWeight: "20px",
              }}
            >
              {!isDistrictSi && name}
            </Typography>
          </div>
          {member
            ? okatakiGohonzonQuestionsForMember.map((question, index) => {
                const answer = answers?.find(
                  (a) => a.questionId === question.questionId
                );
                const inputStyle =
                  answer && answer.answer === false
                    ? {
                        "&, &.Mui-checked": {
                          color: "red",
                        },
                      }
                    : {};
                return (
                  <>
                    <Box
                      style={{
                        width: "100%",
                        padding: "0px 20px",
                      }}
                    />
                    <Box key={question.key}>
                      {question.questionType === DROPDOWN ? (
                        <Box
                          style={{
                            ...styles.gridItem,
                            width: "100%",
                            backgroundColor: "#ECECEC",
                            padding: "10px 20px 10px 20px",
                          }}
                        >
                          <Typography
                            variant="mini"
                            color="#5e5e5e"
                            weight={600}
                          >
                            DURATION OF PRACTICE (Minimum 6 Months){" "}
                            <Typography variant="small" color="#FF6A69">
                              *
                            </Typography>
                          </Typography>
                          <Box width="45%" paddingLeft="10%">
                            <SelectMonthAndYear
                              name={GOHONZON_SUBMISSION.DURATION_OF_PRACTICE}
                              value={getAnswerValue(question)}
                              readOnly={readOnly}
                              setFieldValue={setFieldValue}
                              required
                            />
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          key={question.key}
                          sx={{
                            width: "100%",
                            background: index % 2 === 0 ? "#ECECEC" : "#F6F6F6",
                            padding: "10px 20px 10px 20px",
                          }}
                        >
                          <GohonzonOtherInput
                            preLabel={question.ques}
                            name={question.name}
                            size="small"
                            onChange={handleChange}
                            value={getAnswerValue(question)}
                            readOnly={readOnly}
                            required
                            inputStyle={inputStyle}
                          />
                        </Box>
                      )}
                    </Box>
                  </>
                );
              })
            : okatakiGohonzonQuestions.map((question, index) => {
                const answer = answers?.find(
                  (a) => a.questionId === question.questionId
                );
                const inputStyle =
                  answer && answer.answer === false
                    ? {
                        "&, &.Mui-checked": {
                          color: "red",
                        },
                      }
                    : {};
                return (
                  <>
                    <Box
                      style={{
                        width: "100%",
                        padding: "0px 20px",
                      }}
                    />
                    <Box key={question.key}>
                      {question.questionType === DROPDOWN ? (
                        <Box
                          style={{
                            ...styles.gridItem,
                            width: "100%",
                            backgroundColor: "#ECECEC",
                            padding: "10px 20px 10px 20px",
                          }}
                        >
                          <Typography
                            variant="mini"
                            color="#5e5e5e"
                            weight={600}
                          >
                            DURATION OF PRACTICE (Minimum 6 Months){" "}
                            <Typography variant="small" color="#FF6A69">
                              *
                            </Typography>
                          </Typography>
                          <Box width="45%" paddingLeft="10%">
                            <SelectMonthAndYear
                              name={GOHONZON_SUBMISSION.DURATION_OF_PRACTICE}
                              value={getAnswerValue(question)}
                              readOnly={readOnly}
                              setFieldValue={setFieldValue}
                              required
                            />
                          </Box>
                        </Box>
                      ) : question.questionType === PROPOSED ? (
                        <Box
                          style={{
                            ...styles.gridItem,
                            width: "100%",
                            padding: "10px 20px 10px 20px",
                          }}
                        >
                          <GohonzonOtherInput
                            name={GOHONZON_SUBMISSION.PLACE_OF_ENSHRINED}
                            value={getAnswerValue(question)}
                            handleChange={handleChange}
                            preLabel="PROPOSED PLACE FOR ENSHRINING GOHONZON"
                            buttonLabels={["Approved", "Not Approved"]}
                            required
                            readOnly={readOnly}
                            inputStyle={inputStyle}
                          />{" "}
                        </Box>
                      ) : (
                        <Box
                          key={question.key}
                          sx={{
                            width: "100%",
                            background: index % 2 === 0 ? "#ECECEC" : "#F6F6F6",
                            padding: "10px 20px 10px 20px",
                          }}
                        >
                          <GohonzonOtherInput
                            preLabel={question.ques}
                            name={question.name}
                            size="small"
                            onChange={handleChange}
                            value={getAnswerValue(question)}
                            readOnly={readOnly}
                            required
                            inputStyle={inputStyle}
                          />
                        </Box>
                      )}
                    </Box>
                  </>
                );
              })}
        </Box>
      </Box>
    </Box>
  );
}

export default OkatakiFormQuestion;
